import { createThemeCompiler } from '../../../utils';

export const toggleInputThemeCompiler = createThemeCompiler(({ palette, borderRadius, stroke, boxShadow }) => ({
    toggleInput: {
        colors: {
            default: {
                backgroundColor: '#CACED5',
                knobBackgroundColor: palette.white,
                knobBorderColor: palette.neutralTertiary
            },
            checked: {
                backgroundColor: palette.themePrimary,
                knobBackgroundColor: palette.white,
                knobBorderColor: palette.neutralQuaternary
            },
            disabled: {
                backgroundColor: palette.neutralSecondaryAlt,
                knobBackgroundColor: palette.neutralQuaternary,
                knobBorderColor: palette.neutralTertiary
            },
            disabledChecked: {
                backgroundColor: palette.themeTertiary,
                knobBackgroundColor: palette.themeLighter,
                knobBorderColor: palette.themeLight
            },
            hovered: {
                backgroundColor: '#B3B6BD',
                knobBackgroundColor: palette.white,
                knobBorderColor: palette.neutralQuaternary
            },
            hoveredChecked: {
                backgroundColor: palette.themeTertiary,
                knobBackgroundColor: palette.white,
                knobBorderColor: palette.neutralQuaternary
            }
        },
        composites: {
            borderRadius: borderRadius.curvedXLarge,
            knobBorderRadius: borderRadius.circle,
            knobBorderWidth: stroke.none,
            boxShadow: boxShadow.normal
        }
    }
}));
